
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  name: 'LocationCard',
  props: {
    location: Object,
    image: String,
  },
  computed: {
    ...mapState([ 'user', 'appInfo', 'cart' ]),
    ...mapState({
      favLocs: state => state.members.favLocs,
      handoffMode: state => state.order.handoffMode,
      loading: state => state.loading,
    }),
    locationImage() {
      if(this.image) {
        return {
          backgroundImage: `url(${this.image})`
        }
      }
    },

    appHandoffModes() {
      return this.appInfo.order['handoff_modes']
    },

    locationHandoffModes() {
      if (this.location) {
        return this.$utils.locationHandoffModes(this.location, this.appHandoffModes)
      }

      return []
    },

    locationDisabled() {
      return !this.location.services[this.handoffMode]
    },

    isFavorite() {
      return !!(this.favLocs && this.favLocs.find(f => f.id === this.location.id))
    },

    services() {
      if (this.location && this.location.services) {
        const services = []
        if (this.location.services.delivery) {
          services.push({
            name: 'Delivery',
            iconName: 'delivery-icon',
            iconClasses: 'delivery-icon',
          })
        }
        if (this.location.services?.pickup) {
          services.push({
            name: 'Pickup',
            iconName: 'pickup-icon',
            iconClasses: 'pickup-icon',
          })
        }
        if (this.location.services?.curbside) {
          services.push({
            name: 'Curbside',
            iconName: 'curbside-icon',
            iconClasses: 'curbside-icon',
          })
        }
        if (this.location.services?.drivethru) {
          services.push({
            name: 'Drive Thru',
            iconName: 'curbside-icon',
            iconClasses: 'curbside-icon',
          })
        }
        return services
      }

      return []
    },
  },
  methods: {
    ...mapMutations([ 'setLocation', 'setMenu' ]),
    ...mapActions([ 'transferCart', 'trackEvent' ]),
    ...mapActions({
      saveFavLoc: 'members/saveFavLoc',
      deleteFavLoc: 'members/deleteFavLoc',
    }),
    async favorite() {
      const favLocFound = this.favLocs.find(l => l.id === this.location.id)
      if (favLocFound){
        await this.deleteFavLoc(this.location.menu_id)
      } else {
        const response = await this.saveFavLoc(this.location.menu_id)
        if (response) {
          this.trackEvent({
            name: 'location_favorited',
            data: this.location,
            windowObject: window
          })
        }
      }
    },
    handleSelectLocation() {
      // Transfer cart when changing locations
      if (this.cart && this.cart.menu_id !== this.location.menu_id) {
        this.transferCart(this.location.menu_id)
      }
      if (this.location) {
        this.trackEvent({
          name: 'select_location',
          data: this.location,
          windowObject: window
        })
      }
      this.setLocation(this.location)
      this.setMenu(null)
      this.$router.push(`/menu/${this.location.menu_id}`)
    },
  },
}

